/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { HttpClient } from '@angular/common/http';
import { IpUserRestApiService } from './user-rest-api.service';

/**
 * @internal
 * The free User Rest API service for Regular license.
 * No differences between other licenses for now, but might be in the future.
 */
export default class FreeUsersRestApi extends IpUserRestApiService {
  constructor(http: HttpClient) {
    super(http);
  }
}
